<div class="flex-fill d-flex flex-column">
    <div class="m-1 grid-fill" style="max-width: 100%" *ngIf="purchases">
        <dx-data-grid
            #dataGrid
            [dataSource]="purchases"
            keyExpr="id"
            [columnAutoWidth]="false"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onSelectionChanged)="selectionChange($event)"
            (onExporting)="onExporting($event)"
        >
            <dxi-column dataField="part.preferredVendor" caption="Vendor" width="200"></dxi-column>
            <dxi-column dataField="part.partNumber" caption="Part Number" width="250"></dxi-column>
            <dxi-column dataField="part.description" caption="Description" width="350"></dxi-column>
            <dxi-column dataField="quantity" width="100"></dxi-column>
            <dxi-column dataField="date" editorType="dxDate" width="100"></dxi-column>
            <dxi-column dataField="price" width="100" [format]="{ type: 'currency', precision: 4 }"></dxi-column>
            <dxi-column dataField="reason" width="200"></dxi-column>
            <dxi-column dataField="createdBy" caption="Created By" width="120"></dxi-column>
            <dxi-column dataField="inStock" width="100"></dxi-column>
            <dxi-column dataField="allocated" width="100"></dxi-column>
            <dxi-column dataField="projectedInventory" width="100"></dxi-column>
            <dxi-column dataField="enteredAmount" width="100"></dxi-column>
            <dxi-column dataField="attachmentsHTML" caption="Attachments" width="200" [encodeHtml]="false"></dxi-column>

            <dxo-remote-operations [sorting]="true" [paging]="true" [filtering]="true"></dxo-remote-operations>
            <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
            <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-state-storing [enabled]="true" type="localStorage" storageKey="part-purchases-grid"></dxo-state-storing>
            <div *dxTemplate="let data of 'toolbarButtons'"></div>
            <div *dxTemplate="let data of 'toolbarText'">
                <span *ngIf="purchases" class="me-3"
                    ><strong>{{ dataGrid.instance.totalCount() + ' items' }}</strong></span
                >
            </div>
        </dx-data-grid>
    </div>
</div>
